<mat-card>
  @if (documentService.savedDocuments().length > 0) {
      <h3>Uppladdade dokument</h3>
      @for (document of documentService.savedDocuments(); track document.id) {
        <spb-selected
          color="#E0E0E0"
          [document]="document"
          [removable]="!document.isPermanent"
          (remove)="deleteFile(document.id, document.name)"
        ></spb-selected>
      }
  }

  <div style="text-align: center">
    @if (documentService.savedDocuments().length <= 0) {
      <p [style.margin.px]="0">Inga dokument har skickats</p>
    }
    <button (click)="configService.reset()"
            matButton="outlined">
      Avsluta / ny person
    </button>
  </div>
</mat-card>
